import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    IconButton,
    Button,
    Tab,
    Tabs,
    Tooltip
} from '@mui/material';
import {
    Add as AddIcon,
    Close as CloseIcon,
    InventoryOutlined as InventoryIcon,
    CollectionsOutlined as CollectionsIcon,
    Check,
    ArrowBack as ArrowLeftIcon,
    ArrowForward as ArrowRightIcon,
    Star as StarIcon,
    StarBorder as StarBorderIcon
} from '@mui/icons-material';
import LayersIcon from '@mui/icons-material/Layers';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { apiUrl } from '../../comp/ApiUrl';
import { WithRouter } from '../../comp/WithRouter';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

class EditPhotosProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fotos: [], // Lista unificada: { id?, name?, file?, url, isBlob, principal }
            fotosRemovidasIds: [], // IDs de fotos do banco que foram removidas pelo usuário
            isSaving: false,
            hasChanges: false // Controla se houve alteração pendente de salvamento
        };
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        document.title = 'Editar Fotos do Produto';
        this.buscarFotosProduto();

        // Alerta o usuário caso ele tente fechar ou recarregar a aba sem salvar
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);

        // Limpa URLs Blob para evitar vazamento de memória do navegador
        this.state.fotos.forEach(foto => {
            if (foto.isBlob && foto.url) {
                URL.revokeObjectURL(foto.url);
            }
        });
    }

    // Impede o fechamento acidental da página se houver alterações
    handleBeforeUnload = (event) => {
        if (this.state.hasChanges) {
            event.preventDefault();
            event.returnValue = ''; // Exigido por navegadores modernos para exibir a caixa de diálogo nativa
        }
    };

    // Intercepta a navegação via abas do React Router
    handleNavigate = (event, to) => {
        if (this.state.hasChanges) {
            const confirmLeave = window.confirm(
                'Você tem alterações não salvas nas fotos. Se sair agora, as alterações serão perdidas. Deseja continuar?'
            );
            if (!confirmLeave) {
                event.preventDefault(); // Cancela a navegação do Link/Tab
            }
        }
    };

    // Busca as fotos salvas via API ao carregar ou recarregar a página
    buscarFotosProduto = () => {
        fetch(`${apiUrl}/produtos/get/photos/${this.props.params.uuid}`, {
            method: "GET",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                throw new Error("Erro ao carregar produto");
            })
            .then((data) => {
                const fotosServidor = (data.fotos || []).map((foto, index) => ({
                    id: foto.id,
                    name: foto.url || foto.name,
                    url: `${apiUrl}/static/${foto.url || foto.name}`,
                    isBlob: false,
                    principal: index === 0
                }));

                this.setState({
                    fotos: fotosServidor,
                    fotosRemovidasIds: [],
                    hasChanges: false // Reseta a flag de alterações após carregar
                });
            })
            .catch((error) => {
                console.error("Erro ao buscar fotos:", error);
                toast.error("Erro ao carregar as fotos do produto.");
            });
    };

    // Seleção de arquivo local - cria preview via Blob
    handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        if (files.length === 0) return;

        const novasFotos = files.map((file) => ({
            file,
            url: URL.createObjectURL(file),
            isBlob: true,
            principal: false
        }));

        this.setState((prevState) => {
            const listaAtualizada = [...prevState.fotos, ...novasFotos];

            if (listaAtualizada.length > 0 && !listaAtualizada.some(f => f.principal)) {
                listaAtualizada[0].principal = true;
            }

            return { fotos: listaAtualizada, hasChanges: true };
        });

        event.target.value = '';
    };

    // Remove foto localmente
    handleRemoverFoto = (index) => {
        this.setState((prevState) => {
            const fotoRemovida = prevState.fotos[index];
            const fotosRemovidasIds = [...prevState.fotosRemovidasIds];

            if (!fotoRemovida.isBlob && fotoRemovida.id) {
                fotosRemovidasIds.push(fotoRemovida.id);
            }

            if (fotoRemovida.isBlob && fotoRemovida.url) {
                URL.revokeObjectURL(fotoRemovida.url);
            }

            const novasFotos = prevState.fotos.filter((_, i) => i !== index);

            if (fotoRemovida.principal && novasFotos.length > 0) {
                novasFotos[0].principal = true;
            }

            return { fotos: novasFotos, fotosRemovidasIds, hasChanges: true };
        });
    };

    // Altera a ordem das fotos
    handleMoverFoto = (index, direcao) => {
        this.setState((prevState) => {
            const novasFotos = [...prevState.fotos];
            const novoIndex = index + direcao;

            if (novoIndex < 0 || novoIndex >= novasFotos.length) return null;

            const temp = novasFotos[index];
            novasFotos[index] = novasFotos[novoIndex];
            novasFotos[novoIndex] = temp;

            novasFotos.forEach((f, i) => {
                f.principal = i === 0;
            });

            return { fotos: novasFotos, hasChanges: true };
        });
    };

    // Define uma foto como capa/principal
    handleSetPrincipal = (index) => {
        this.setState((prevState) => {
            const novasFotos = prevState.fotos.map((foto, i) => ({
                ...foto,
                principal: i === index
            }));

            novasFotos.sort((a, b) => (b.principal ? 1 : 0) - (a.principal ? 1 : 0));

            return { fotos: novasFotos, hasChanges: true };
        });
    };

    // Salva as fotos e limpa o aviso de alterações
    handleSalvar = async () => {
        const { fotos, fotosRemovidasIds } = this.state;
        const toastId = toast.loading("Salvando fotos do produto...");
        this.setState({ isSaving: true });

        try {
            const formData = new FormData();
            formData.append("uuid", this.props.params.uuid);
            formData.append("removidas", JSON.stringify(fotosRemovidasIds));

            const fotosExistentes = [];

            fotos.forEach((foto) => {
                if (foto.isBlob && foto.file) {
                    formData.append("images", foto.file);
                } else {
                    fotosExistentes.push({
                        id: foto.id,
                        name: foto.name,
                        principal: foto.principal
                    });
                }
            });

            formData.append("fotosExistentes", JSON.stringify(fotosExistentes));

            const response = await fetch(`${apiUrl}/products/upload-images/${this.props.params.uuid}`, {
                method: "POST",
                credentials: "include",
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                toast.update(toastId, {
                    render: "Fotos salvas com sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 3000
                });

                this.setState({ hasChanges: false }, () => {
                    this.buscarFotosProduto();
                });
            } else {
                throw new Error(data.error || "Erro ao salvar alterações.");
            }
        } catch (error) {
            console.error("Erro ao salvar fotos:", error);
            toast.update(toastId, {
                render: error.message || "Falha ao salvar fotos.",
                type: "error",
                isLoading: false,
                autoClose: 3000
            });
        } finally {
            this.setState({ isSaving: false });
        }
    };

    triggerFileSelect = () => {
        this.fileInputRef.current.click();
    };

    render() {
        const { fotos, isSaving, hasChanges } = this.state;
        const uuid = this.props.params.uuid;

        return (
            <Box sx={{ p: 0, backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                <input
                    type="file"
                    multiple
                    accept="image/*"
                    ref={this.fileInputRef}
                    style={{ display: 'none' }}
                    onChange={this.handleFileChange}
                />

                {/* Topbar */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4 }}>
                    <Box>
                        <Typography variant="h5" fontWeight="700" gutterBottom>
                            Editar Produto
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Gerencie e reordene as fotos do seu produto
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        onClick={this.handleSalvar}
                        disabled={isSaving}
                        startIcon={<Check />}
                        color={hasChanges ? "primary" : "inherit"}
                        sx={{ borderRadius: '8px', textTransform: 'none' }}
                    >
                        {hasChanges ? "Salvar Fotos *" : "Salvar Fotos"}
                    </Button>
                </Box>

                {/* Abas com Interceptação de Clique */}
                <Box sx={{ mb: 4 }}>
                    <Tabs
                        value={1}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        sx={{
                            '& .MuiTabs-indicator': { display: 'none' },
                            '& .MuiTabs-scroller': { overflowX: 'auto' },
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                minHeight: '40px',
                                borderRadius: '8px',
                                mr: 1,
                                fontWeight: 500,
                                color: '#666',
                                whiteSpace: 'nowrap',
                                flexShrink: 0
                            },
                            '& .Mui-selected': {
                                bgcolor: '#fff',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                color: '#000 !important'
                            }
                        }}
                    >
                        <Tab
                            component={Link}
                            to={`/produtos/${uuid}/basic`}
                            onClick={(e) => this.handleNavigate(e, `/produtos/${uuid}/basic`)}
                            icon={<InventoryIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Informações Básicas"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${uuid}/photos`}
                            icon={<CollectionsIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Fotos do Produto"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${uuid}/price`}
                            onClick={(e) => this.handleNavigate(e, `/produtos/${uuid}/price`)}
                            icon={<AttachMoneyIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Preço"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${uuid}/attributes`}
                            onClick={(e) => this.handleNavigate(e, `/produtos/${uuid}/attributes`)}
                            icon={<LayersIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Atributos & Variações"
                        />
                    </Tabs>
                </Box>

                {/* Card do Grid de Fotos */}
                <Card sx={{ mb: 3, borderRadius: 3, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)', border: '1px solid #e2e8f0' }}>
                    <CardContent sx={{ p: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                            <Box sx={{ bgcolor: '#f3e5f5', p: 1, borderRadius: 2, display: 'flex' }}>
                                <CollectionsIcon sx={{ color: '#9c27b0' }} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                    Fotos do produto
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                    {fotos.length} {fotos.length === 1 ? 'foto selecionada' : 'fotos selecionadas'}
                                </Typography>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                            {fotos.map((foto, index) => (
                                <Box
                                    key={foto.id || foto.name || foto.url}
                                    sx={{
                                        width: 150,
                                        height: 150,
                                        position: 'relative',
                                        borderRadius: 2,
                                        border: foto.principal ? '2px solid #9c27b0' : '1px solid #e2e8f0',
                                        backgroundImage: `url(${foto.url})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        p: 0.5
                                    }}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                        <Tooltip title={foto.principal ? "Foto Principal" : "Definir como Principal"}>
                                            <IconButton
                                                size="small"
                                                onClick={() => this.handleSetPrincipal(index)}
                                                sx={{
                                                    backgroundColor: 'rgba(255,255,255,0.85)',
                                                    color: foto.principal ? '#9c27b0' : '#64748b',
                                                    '&:hover': { backgroundColor: '#fff' }
                                                }}
                                            >
                                                {foto.principal ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
                                            </IconButton>
                                        </Tooltip>

                                        <IconButton
                                            size="small"
                                            onClick={() => this.handleRemoverFoto(index)}
                                            sx={{
                                                backgroundColor: '#ef4444',
                                                color: 'white',
                                                '&:hover': { backgroundColor: '#dc2626' }
                                            }}
                                        >
                                            <CloseIcon sx={{ fontSize: 16 }} />
                                        </IconButton>
                                    </Box>

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'rgba(0,0,0,0.4)', borderRadius: 1, p: 0.2 }}>
                                        <IconButton
                                            size="small"
                                            disabled={index === 0}
                                            onClick={() => this.handleMoverFoto(index, -1)}
                                            sx={{ color: 'white', '&.Mui-disabled': { color: 'rgba(255,255,255,0.3)' } }}
                                        >
                                            <ArrowLeftIcon fontSize="small" />
                                        </IconButton>

                                        {foto.principal && (
                                            <Typography variant="caption" sx={{ color: '#fff', fontSize: '10px', fontWeight: 'bold' }}>
                                                PRINCIPAL
                                            </Typography>
                                        )}

                                        <IconButton
                                            size="small"
                                            disabled={index === fotos.length - 1}
                                            onClick={() => this.handleMoverFoto(index, 1)}
                                            sx={{ color: 'white', '&.Mui-disabled': { color: 'rgba(255,255,255,0.3)' } }}
                                        >
                                            <ArrowRightIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Box>
                            ))}

                            <Box
                                onClick={this.triggerFileSelect}
                                sx={{
                                    width: 150,
                                    height: 150,
                                    border: '2px dashed #cbd5e1',
                                    borderRadius: 2,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    transition: 'all 0.2s',
                                    '&:hover': { borderColor: '#7c3aed', backgroundColor: '#f8f5ff' }
                                }}
                            >
                                <AddIcon sx={{ color: '#64748b', fontSize: 28, mb: 0.5 }} />
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 500 }}>
                                    Adicionar Fotos
                                </Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        );
    }
}

export default WithRouter(EditPhotosProduct);